module.exports = "/_next/static/images/0787832f6fdd0841ac62d9b628ce4f4f-hero-cultural-hack-xs-2x.jpg";